import { useEffect, useState, useRef } from "react";
import { actionPhotos } from "@/mocks/productsCdbjjLP";

const PHG_LOGO = "/images/phg-logo.png";
const CDBJJ_LOGO = "/images/carpe2.png";

// cdbjj用ヒーロースライド写真
const heroSlides = [
  "/images/A1_5300.jpg", // 1枚目
  actionPhotos[13], // GRAY5人整列（Carpe Diemロゴ壁）
  actionPhotos[17], // H/S系（元1枚目）
];

export default function CdbjjHero() {
  const [slide, setSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    setLoaded(true);
    timerRef.current = setInterval(() => {
      setSlide((s) => (s + 1) % heroSlides.length);
    }, 6000);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, []);

  return (
    <section className="relative w-full bg-black overflow-hidden" style={{ minHeight: "100vh" }}>

      {/* ── BACKGROUND SLIDESHOW ── */}
      {heroSlides.map((src, i) => (
        <div
          key={src}
          className="absolute inset-0 transition-opacity duration-1500"
          style={{ opacity: slide === i ? 1 : 0 }}
        >
          <img src={src} alt="" className="w-full h-full object-cover object-top" style={{ minHeight: "100vh" }} />
        </div>
      ))}

      {/* Dark overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-black/10 z-10" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20 z-10" />

      {/* ── MAIN CONTENT ── */}
      <div className="relative z-20 w-full min-h-screen flex flex-col justify-between px-8 md:px-16 py-10">

        {/* Top bar — CDBJJロゴ左、PHGロゴ右 */}
        <div className={`flex items-center justify-between mt-8 md:mt-14 transition-all duration-700 delay-100 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}`}>
          {/* 左: CDBJJロゴ */}
          <div className="w-[74px] h-[74px] md:w-[300px] md:h-[300px] flex-shrink-0 flex items-center justify-center">
            <img src={CDBJJ_LOGO} alt="Carpe Diem BJJ" className="w-full h-full object-contain opacity-80" style={{ mixBlendMode: "screen" }} />
          </div>

          {/* 右: PHGロゴ */}
          <div className="flex items-center gap-4">
            <span className="hidden md:block text-white/50 text-sm tracking-widest uppercase">Active Collection 2026</span>
            <div className="hidden md:block w-px h-8 bg-white/20" />
            <div className="w-[80px] h-[80px] md:w-[325px] md:h-[325px] flex-shrink-0 flex items-center justify-center">
              <img src={PHG_LOGO} alt="Powerhouse Gym" className="w-full h-full object-contain opacity-80" style={{ mixBlendMode: "screen" }} />
            </div>
          </div>
        </div>

        {/* Center: 大見出し + サブテキスト */}
        <div className="flex flex-col md:flex-row flex-1 py-6 md:py-8">

          {/* 大見出し */}
          <div className="flex flex-col justify-end flex-1">
            <div className={`transition-all duration-700 delay-200 ${loaded ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
              <span className="inline-block text-red-600 text-sm tracking-[0.4em] uppercase mb-4 md:mb-6 border-l-2 border-red-600 pl-3">
                more than jiu-jitsu
              </span>
            </div>
            <div className={`transition-all duration-700 delay-300 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <h1
                className="text-white font-black uppercase leading-none"
                style={{
                  fontFamily: "'Bebas Neue', sans-serif",
                  fontSize: "clamp(60px, 9vw, 140px)",
                  letterSpacing: "-0.01em",
                  lineHeight: 0.88,
                }}
              >
                LIVE<br />
                <span className="text-red-600">THE</span><br />
                DISCIPLINE
              </h1>
            </div>
          </div>

          {/* サブテキスト＋ボタン */}
          <div className="flex flex-col justify-end md:items-end mt-8 md:mt-0 md:pb-2 md:pl-8">
            <div className={`transition-all duration-700 delay-500 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <p className="text-white/65 text-sm md:text-base leading-loose md:text-right mb-6 md:mb-10">
                知性を磨く柔術と、世界基準の情熱が交わる場所。<br />
                カルペ・ディエムが放つ、渾身のコレクション。
              </p>
            </div>
            <div className={`flex flex-row md:flex-col items-center md:items-end gap-4 transition-all duration-700 delay-600 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <a
                href="https://carpediembjj.store/collections/powerhouse-gym-carpe-diem"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-white hover:bg-red-600 text-black hover:text-white text-sm tracking-[0.3em] uppercase px-6 md:px-8 py-3 md:py-4 transition-all duration-300 whitespace-nowrap cursor-pointer font-bold"
              >
                COLLECTION
                <i className="ri-arrow-right-line" />
              </a>
              <a href="#product-rush-ls" className="text-white/55 hover:text-white text-sm tracking-widest uppercase transition-colors whitespace-nowrap cursor-pointer">
                詳細を見る
              </a>
            </div>
          </div>
        </div>

        {/* Bottom: slide indicator */}
        <div className={`transition-all duration-700 delay-700 ${loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex items-center gap-3">
            {heroSlides.map((_, i) => (
              <button
                key={i}
                onClick={() => setSlide(i)}
                className={`transition-all duration-300 cursor-pointer ${slide === i ? "w-10 h-0.5 bg-red-600" : "w-3 h-0.5 bg-white/30 hover:bg-white/60"}`}
              />
            ))}
            <span className="text-white/40 text-xs tracking-widest ml-4 uppercase">
              {String(slide + 1).padStart(2, "0")} / {String(heroSlides.length).padStart(2, "0")}
            </span>
          </div>
        </div>
      </div>

      {/* ── SCROLL INDICATOR ── */}
      <div className="absolute bottom-8 right-12 z-30 flex flex-col items-center gap-2">
        <div className="w-px h-12 bg-white/20" />
        <span className="text-white/35 text-xs tracking-[0.4em] uppercase" style={{ writingMode: "vertical-rl" }}>Scroll</span>
      </div>
    </section>
  );
}
